
<div class="modal-header">
    <h5 class="modal-title">Change Password</h5>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>Changing password for: <strong>{{user.email}}</strong></p>
    <div class="form-group">
        <label for="newPassword">New Password</label>
        <input type="password" 
               class="form-control" 
               id="newPassword" 
               [(ngModel)]="newPassword"
               [class.is-invalid]="passwordError"
               placeholder="Enter new password"
               (input)="clearPasswordError()">
        <div class="invalid-feedback" *ngIf="passwordError">
            {{passwordError}}
        </div>
        <small class="form-text text-muted">
            Password must be at least 6 characters long
        </small>
    </div>
    <div class="form-group">
        <label for="confirmPassword">Confirm Password</label>
        <input type="password" 
               class="form-control" 
               id="confirmPassword" 
               [(ngModel)]="confirmPassword"
               [class.is-invalid]="confirmPasswordError"
               placeholder="Confirm new password"
               (input)="clearPasswordError()">
        <div class="invalid-feedback" *ngIf="confirmPasswordError">
            {{confirmPasswordError}}
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()">Change Password</button>
</div>